import { useSyncExternalStore } from "react";

export interface Toast {
  id: number;
  message: string;
  tone: "info" | "error";
  action?: { label: string; run: () => void };
}

let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function toast(message: string, opts: { tone?: Toast["tone"]; action?: Toast["action"]; ms?: number } = {}) {
  const t: Toast = { id: nextId++, message, tone: opts.tone ?? "info", action: opts.action };
  // One at a time keeps the screen calm; the newest message wins.
  toasts = [t];
  emit();
  setTimeout(() => dismiss(t.id), opts.ms ?? (opts.tone === "error" ? 7000 : 4500));
}

export function dismiss(id: number) {
  const before = toasts.length;
  toasts = toasts.filter((t) => t.id !== id);
  if (toasts.length !== before) emit();
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => toasts,
  );
}
